<div class="hflex-000 flex-align-items-center flex-justify-content-space-around">
  <div class="hflex-000 flex-align-items-center flex-justify-content-center">
    <button
      class="mdw-button mdw-tertiary small-button"
      [icon]="icons.Navigate_Previous"
      data-pw="prev-month-button"
      (click)="changeMonth(-1)"
    >
    </button>
    <button
      class="mdw-button mdw-tertiary small-button"
      data-pw="select-month-button"
      [showDownArrow]="true"
      (click)="setView('year')"
    >
      {{ monthLabel() }}
    </button>
    <button
      class="mdw-button mdw-tertiary small-button"
      data-pw="next-month-button"
      [icon]="icons.Navigate_Next"
      (click)="changeMonth(1)"
    >
    </button>
  </div>
  <div class="hflex-000 flex-align-items-center flex-justify-content-center">
    <button
      class="mdw-button mdw-tertiary small-button"
      data-pw="prev-year-button"
      (click)="changeYear(-1)"
      [icon]="icons.Navigate_Previous"
    >
    </button>
    <button
      class="mdw-button mdw-tertiary small-button"
      data-pw="select-year-button"
      [showDownArrow]="true"
      (click)="setView('multi-year')"
    >
      {{ yearLabel() }}
    </button>
    <button
      class="mdw-button mdw-tertiary small-button"
      data-pw="next-year-button"
      (click)="changeYear(1)"
      [icon]="icons.Navigate_Next"
    >
    </button>
  </div>
</div>
